<template>
  <v-dialog
    :fullscreen="$vuetify.breakpoint.smAndDown"
    v-model="dialog"
    @keydown.esc="cancel"
    :max-width="$vuetify.breakpoint.smAndDown ? 'none' : '600px'"
    content-class="fullscreen-dialog"
    persistent
  >
    <v-card class="dialog-card">
      <v-toolbar color="primary" dense class="header primaryText--text">
        <v-row>
          <v-col cols="2" align-self="end">
            <v-btn text @click="close(false)">{{ $t("close") }}</v-btn>
          </v-col>

          <v-col cols="8" class="d-flex justify-center align-center">
            <div>
              <v-toolbar-title
                class="header-title1"
                v-if="$appMode == 0 && $store.state.store != null && $store.state.store.info != null"
                >{{ $store.getters.storeName }}</v-toolbar-title
              >
              <v-toolbar-title class="header-title2">{{ $t("phone_verification") }}</v-toolbar-title>
            </div>
          </v-col>

          <v-col cols="2" align-self="end" style="text-align:right"></v-col>
        </v-row>
      </v-toolbar>

      <v-card-text>
        <v-form v-model="valid" ref="form">
          <v-container>
            <v-list-item>
              <v-text-field v-model="phone" disabled :label="$t('phone')" required></v-text-field>
            </v-list-item>

            <v-list-item>
              <v-text-field
                v-model="vcode"
                :rules="[inputRules.vcode]"
                :label="$t('verification_code')"
                required
              ></v-text-field>
            </v-list-item>
            <v-btn class="horizontal-center verify-button" :disabled="!valid" @click="verify">{{ $t("verify") }}</v-btn>

            <div v-if="verifyFailed" class="invalid-message">{{ $t("error_invalid_verification_code") }}</div>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,

    valid: false,
    verifyFailed: false,
    phone: "",
    vtoken: "",
    vcode: "",
    //vcodeRules: [(v) => !!v || "Verification code is required"],
  }),

  methods: {
    open(phone) {
      this.phone = phone;
      this.vtoken = "";
      this.dialog = true;
      this.verifyFailed = false;

      this.rest_requestSmsVerificationCode(phone)
        .then((resp) => {
          console.log(resp);
          if (resp.result == "ok") {
            this.vtoken = resp.validate.Token;
          }
        });

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    close(result) {
      this.$refs.form.reset();
      this.dialog = false;
      this.resolve(result);
    },

    verify() {
      this.verifyFailed = false;
      this.rest_verifySmsVerificationCode(this.phone, this.vcode, this.vtoken)
        .then((resp) => {
          if (resp.result == "ok") {
            this.close(true);
          } else {
            this.verifyFailed = true;
          }
        })
        .catch((error) => {
          console.log(error);
          this.verifyFailed = true;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.verify-button {
  margin-top: 10px;

  background-color: var(--v-primary-base) !important;
  color: var(--v-primaryText-base) !important;  
}

.theme--light.v-btn.v-btn--disabled.verify-button {
  background-color: var(--v-primary-base) !important;
  color: var(--v-primaryText-base) !important;
}

.invalid-message {
  text-align: center;
  margin-top: 30px;
  color: red;
}
</style>
